import { Formik } from 'formik';
import React from 'react';
import { Button, Header } from 'semantic-ui-react';
import { Profile } from '../../app/models/profile';
import { Form } from 'react-router-dom';
import { MyTextInput } from '../../app/common/form/MyTextInput';
import { MyTextArea } from '../../app/common/form/MyTextArea';
import * as Yup from 'yup';

interface Props {
  displayName: string;
  onSave: (profile: Partial<Profile>) => Promise<void>;
  onCancel: () => void;
  bio?: string;
}

const ProfileEditForm: React.FC<Props> = ({
  displayName,
  onSave,
  onCancel,
  bio = '',
}) => {
  const initialFormValues: Partial<Profile> = {
    displayName,
    bio,
  };

  const validationSchema = Yup.object({
    displayName: Yup.string().required('Display name is required'),
  });

  return (
    <>
      <Header size="medium" sub>
        {`Editing Profile for ${displayName}`}
      </Header>
      <Formik
        enableReinitialize
        initialValues={initialFormValues}
        validationSchema={validationSchema}
        onSubmit={(values) => onSave(values)}
      >
        {({ handleSubmit, isValid, isSubmitting, dirty }) => (
          <Form className="ui form" onSubmit={handleSubmit} autoComplete="off">
            <MyTextInput name="displayName" placeholder={displayName} />
            <MyTextArea placeholder="Enter your bio" name="bio" rows={8} />
            <Button
              disabled={isSubmitting || !dirty || !isValid}
              loading={isSubmitting}
              floated="right"
              positive
              type="submit"
              content="Save"
            />
            <Button
              floated="right"
              type="button"
              content="Cancel"
              onClick={onCancel}
            />
          </Form>
        )}
      </Formik>
    </>
  );
};

export { ProfileEditForm };
